import instance from "../http";
import { getHeader } from "../../utils/utils";
import { projectManagement } from "../../constants/path";

export async function getProjects(perPage = 10, page = 1, organization_uuid = '') {
    const headers = getHeader();
    const response = await instance.get(projectManagement.GET_PROJECT_LIST + `?page=${page}&perPage=${perPage}&is_active=1${organization_uuid && `&organization_uuid=${organization_uuid}`}`, headers);
    return response;
}

export async function getParticularProjectApi(projectId) {
    const headers = getHeader();
    const response = await instance.get(projectManagement.GET_PARTICULAR_PROJECT + projectId, headers);
    return response;
}

export async function addProjectApi(data) {
    const headers = getHeader();
    const response = await instance.post(projectManagement.ADD_PROJECT, data, headers);
    return response;
}

export async function editProjectApi(projectId, data) {
    const headers = getHeader();
    const response = await instance.put(projectManagement.EDIT_PROJECT + projectId, data, headers);
    return response;
}

export async function deleteProjectApi(projectId) {
    const headers = getHeader();
    const response = await instance.delete(projectManagement.DELETE_PROJECT + projectId, headers);
    return response;
}

export async function swicthProjectApi(search) {
    const headers = getHeader();
    const response = await instance.get(projectManagement.SWITCH_PROJECT_LIST + `?${search && `search=${search}`}`, headers);
    return response;
}